import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withKeys as _withKeys, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "summery-container"
};
const _hoisted_2 = {
  class: "summary-header"
};
const _hoisted_3 = {
  class: "image"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "image"
};
const _hoisted_8 = {
  class: "summary-body"
};
const _hoisted_9 = {
  class: "label"
};
const _hoisted_10 = {
  class: "label"
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "label"
};
const _hoisted_13 = {
  class: "form-layout"
};
const _hoisted_14 = {
  class: "te-notice"
};
const _hoisted_15 = {
  class: "label"
};
const _hoisted_16 = {
  class: "label"
};
const _hoisted_17 = {
  class: "label"
};
const _hoisted_18 = {
  class: "label"
};
const _hoisted_19 = {
  class: "label"
};
const _hoisted_20 = {
  class: "label"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  class: "price"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  class: "form-input"
};
const _hoisted_26 = {
  key: 0,
  class: "el-input__wrapper el-input el-input--small"
};
const _hoisted_27 = {
  class: "el-input__inner"
};
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 1,
  class: "el-input__wrapper el-input el-input--small cursor-pointer"
};
const _hoisted_31 = {
  class: "el-input__inner"
};
const _hoisted_32 = ["innerHTML"];
const _hoisted_33 = ["disabled", "data-text"];
const _hoisted_34 = {
  class: "localized-text"
};
const _hoisted_35 = {
  class: "form-input load-code-input"
};
const _hoisted_36 = {
  class: "writing"
};
const _hoisted_37 = {
  key: 0,
  class: "icon el-text el-text--success"
};
const _hoisted_38 = ["disabled", "data-text"];
const _hoisted_39 = {
  key: 0,
  class: "iconfont icon-mail-fill"
};
const _hoisted_40 = {
  key: 1,
  class: "iconfont icon-quit"
};
const _hoisted_41 = {
  key: 2,
  class: "iconfont icon-hear-full"
};
const _hoisted_42 = {
  key: 3,
  class: "iconfont icon-file-download"
};
const _hoisted_43 = {
  key: 4,
  class: "iconfont icon-help"
};
const _hoisted_44 = {
  key: 5,
  class: "iconfont icon-cart-plus"
};
const _hoisted_45 = {
  key: 6,
  class: "iconfont icon-upload"
};
const _hoisted_46 = {
  key: 7,
  class: "iconfont icon-invoice"
};
const _hoisted_47 = {
  key: 8,
  class: "iconfont icon-reset"
};
const _hoisted_48 = {
  class: "text"
};
const _hoisted_49 = {
  key: 0
};
const _hoisted_50 = {
  key: 0,
  class: "nested-dropdown-container"
};
const _hoisted_51 = ["data-colour", "data-text", "id", "disabled"];
const _hoisted_52 = {
  key: 0,
  class: "iconfont icon-cart-plus"
};
const _hoisted_53 = {
  key: 1,
  class: "iconfont icon-mail-fill"
};
const _hoisted_54 = {
  key: 2,
  class: "iconfont icon-quit"
};
const _hoisted_55 = {
  key: 3,
  class: "iconfont icon-hear-full"
};
const _hoisted_56 = {
  key: 4,
  class: "iconfont icon-file-download"
};
const _hoisted_57 = {
  key: 5,
  class: "iconfont icon-upload"
};
const _hoisted_58 = {
  key: 6,
  class: "iconfont icon-invoice"
};
const _hoisted_59 = {
  key: 7,
  class: "iconfont icon-reset"
};
const _hoisted_60 = {
  class: "collapse-title"
};
const _hoisted_61 = {
  class: "title"
};
const _hoisted_62 = {
  class: "el-dropdown-link"
};
const _hoisted_63 = {
  key: 1,
  class: "only-show-label"
};
const _hoisted_64 = ["innerHTML"];
const _hoisted_65 = ["innerHTML"];
const _hoisted_66 = {
  class: "flex"
};
const _hoisted_67 = {
  class: "flex-body"
};
const _hoisted_68 = {
  class: "text-left"
};
const _hoisted_69 = ["innerHTML"];
const _hoisted_70 = {
  class: "flex"
};
const _hoisted_71 = {
  class: "flex-body"
};
const _hoisted_72 = {
  class: "text-left"
};
const _hoisted_73 = ["innerHTML"];
const _hoisted_74 = {
  class: "flex"
};
const _hoisted_75 = {
  class: "flex-body"
};
const _hoisted_76 = {
  class: "text-left"
};
const _hoisted_77 = {
  class: "localized-text"
};
const _hoisted_78 = {
  class: "list list-row"
};
const _hoisted_79 = {
  key: 0
};
const _hoisted_80 = {
  class: "copy-wrap"
};
const _hoisted_81 = {
  key: 0,
  class: "mt10"
};
const _hoisted_82 = {
  class: "text-left mt10"
};
const _hoisted_83 = {
  class: "text-blue"
};
const _hoisted_84 = {
  class: "text-left"
};
const _hoisted_85 = {
  class: "localized-text"
};
const _hoisted_86 = {
  class: "text-center"
};
const _hoisted_87 = ["data-colour", "disabled", "data-text"];
const _hoisted_88 = {
  key: 0,
  class: "iconfont icon-mail-fill"
};
const _hoisted_89 = {
  key: 1,
  class: "iconfont icon-quit"
};
const _hoisted_90 = {
  key: 2,
  class: "iconfont icon-hear-full"
};
const _hoisted_91 = {
  key: 3,
  class: "iconfont icon-file-download"
};
const _hoisted_92 = {
  key: 4,
  class: "iconfont icon-help"
};
const _hoisted_93 = {
  key: 5,
  class: "iconfont icon-cart-plus"
};
const _hoisted_94 = {
  key: 6,
  class: "iconfont icon-upload"
};
const _hoisted_95 = {
  key: 7,
  class: "iconfont icon-invoice"
};
const _hoisted_96 = {
  key: 8,
  class: "iconfont icon-reset"
};
const _hoisted_97 = {
  class: "text"
};
const _hoisted_98 = {
  class: "in-lightbox"
};
const _hoisted_99 = {
  class: "in-lightbox"
};
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { computed, ref, getCurrentInstance, watch, nextTick, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { default as config } from "@/config.json";
import { openFullLoading, searchCode } from "@/utils/tools";
import useClipboard from "vue-clipboard3";
import Web3dViewer from "./Web3dViewer.vue";
// import { isProductAssembly } from "@/utils/responseUtil";
import { getSubMenuHeight, checkGetDatasheetPermission, onQuantityChanged, quantity, moreButtons, primaryButton, handleButton, qrCodeStr, copyQrCodeHandle, dialogShowQrcode, handleShareQrcode, shareCodeExpairText, buildCodeInput, priceInformation } from "../hooks/summary";
import { useOverlayStore } from "@/stores";
import { useLoaderStore } from "@/stores/loaderState";
import { isProductSelected } from "@/utils/responseUtil";
const labelOverview = "label.Overview";
const labelDetail = "label.Details";
export default /*@__PURE__*/_defineComponent({
  __name: 'productSummary',
  emits: ["switchMainProduct", "resetMainProduct"],
  setup(__props, {
    emit: __emit
  }) {
    const {
      toClipboard
    } = useClipboard();
    const configuratorStore = useConfiguratorStore();
    const additionalStore = useAdditionalAttrStore();
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const {
      t
    } = useI18n();
    const emit = __emit;
    const imageUrl = computed(() => configuratorStore.getSelectedAssemblyImage?.rs_w700_h700_image ?? dataConfig.thumbnailsPlaceholderUrl);
    const hasImage = computed(() => imageUrl.value || configuratorStore.getIsCodingImageSet || fullContentString.value);
    const getAllimages = computed(() => configuratorStore.apiConfiguratorResult?.ConfiguratorResult?.CurrentState?.CurrentCoding.map(item => {
      if (!additionalStore.dataConfig.shellModels?.map(shell => shell.toUpperCase()).includes(item.CodeTypeId) && (item.Optional == "No" || configuratorStore.selectedAssemblies.map(assembly => assembly.codeTypeId).includes(item.CodeTypeId))) {
        return configuratorStore.getImageByCodeTypeId(item.CodeTypeId)?.rs_w700_h700_image;
      }
    }).filter(Boolean));
    const itemExternalNo = computed(() => {
      if (configuratorStore.apiexternalitemid) {
        if (configuratorStore.apiexternalitemid?.itemId) {
          return configuratorStore.apiexternalitemid?.itemId;
        }
      }
      return t("label.notAvailable");
    });
    const itemNumber = computed(() => {
      return configuratorStore.getCurrentState?.CodeComplete ? configuratorStore.getResultData?.ItemInformation?.Item.ItemId : t("label.notAvailable");
    });
    const terminationError = computed(() => {
      return configuratorStore.getCurrentState?.CodeComplete && configuratorStore.resultData?.ItemInformation?.DeliveryInformation.TerminationError;
    });
    const loadCode = ref("");
    const handleLoadCode = () => {
      if (loadCode.value != "") {
        setTimeout(() => {
          searchCode(loadCode.value, true, () => {
            emit("resetMainProduct", "summary");
          }, () => {
            useOverlayStore().setshowShortcodeError(true);
          });
        }, 1000);
      }
    };
    // const stockOnHandVisible = computed(
    //   () =>
    //     configuratorStore.resultData?.ItemInformation?.Stock.IsStockItem ?? false
    // );
    const selectedProductsForCodes = computed(() => {
      const attribute = useAdditionalAttrStore();
      if (attribute.getDataConfig.hideAssemblies) {
        return configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding?.filter(item => {
          return item.CodeTypeId == configuratorStore?.getCurrentType;
        });
      } else {
        return configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding?.filter(item =>
        // isProductAssembly(item) &&
        item.Optional !== "Yes" || configuratorStore.selectedAssemblies.map(assembly => assembly.codeTypeId).includes(item.CodeTypeId) || configuratorStore.getSelectedCertificates.includes(item.CodeTypeId));
      }
    });
    const visibleProductImage = ref(false);
    const visibleProduct2d = ref(false);
    const visibleProduct3d = ref(false);
    const visibleProduct3dWithDownload = ref(false);
    const isShellInArr = computed(() => {
      return additionalStore.dataConfig.shellModels?.map(item => item.toLocaleUpperCase()).includes(configuratorStore?.getCurrentState?.CurrentCoding[0].CodeTypeId ? configuratorStore.getCurrentState.CurrentCoding[0].CodeTypeId.toLocaleUpperCase() : "");
    });
    const configuratorProductImage = computed(() => [{
      src: imageUrl.value,
      title: ""
    }]);
    const configuratorProduct2d = computed(() => [{
      src: configuratorStore.getCodingImageState,
      title: ""
    }]);
    const closeProduct3d = () => {
      visibleProduct3d.value = false;
    };
    const closeProduct3dDownload = () => {
      visibleProduct3dWithDownload.value = false;
    };
    const handleFullscreen = () => {
      if (activeImageName.value == "image") {
        visibleProductImage.value = true;
      }
      if (activeImageName.value == "d2") {
        visibleProduct2d.value = true;
      }
      if (activeImageName.value == "d3") {
        visibleProduct3d.value = true;
      }
    };
    const openToggleMenu = el => {
      el.stopPropagation();
      el?.preventDefault();
      const that = el.currentTarget;
      that?.classList.toggle("active");
      const content = that?.nextElementSibling;
      if (content instanceof HTMLElement) {
        if (content.style.maxHeight) {
          content.style.maxHeight = "";
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    };
    const isTopSticky = ref(false);
    const isBottomSticky = ref(false);
    const handleScroll = () => {
      const controls = document.querySelector(".summary-controls");
      const collapse = document.querySelector(".summary-collapse");
      const body = document.querySelector(".summary-body");
      if (!controls || !collapse || !body) {
        return;
      }
      const controlsRect = controls.getBoundingClientRect();
      const collapseRect = collapse.getBoundingClientRect();
      const bodyRect = body.getBoundingClientRect();
      const tolerance = 1;
      if (controlsRect.bottom > collapseRect.top + tolerance) {
        isTopSticky.value = true;
      } else {
        isTopSticky.value = false;
      }
      if (bodyRect.bottom > controlsRect.top) {
        isBottomSticky.value = true;
      } else {
        isBottomSticky.value = false;
      }
    };
    const priceDetailHtml = computed(() => {
      const resData = configuratorStore.resultData;
      if (resData) {
        const priceData = resData.ItemInformation?.Pricing;
        const html = priceData?.PriceText.split("\n") ?? [];
        const table = ref("");
        table.value += "<table class='in-table'>";
        table.value += "<colgroup><col /><col width='30%' /></colgroup>";
        let tdClass = "";
        html.forEach((v, i) => {
          if (i == 0) {
            table.value += "<tr><td colspan='2'>" + v + "</td></tr>";
          } else {
            if (v.indexOf(":") > 0) {
              const cols = v.split(":");
              if (!cols[1]) {
                cols[1] = cols[2];
              }
              table.value += "<tr><td class='" + tdClass + "'>" + (cols[0] == "" ? "" : (i == html.length - 1 ? "<strong>" + cols[0] + "</strong>" : cols[0]) + ":") + "</td><td class='text-right'>" + (i == html.length - 1 ? "<strong>" + cols[1] + "</strong>" : cols[1]) + "</td></tr>";
            } else {
              if (v.indexOf("---") > -1 || v.indexOf("===") > -1) {
                let doubleLine = false;
                if (v.indexOf("===") > -1) {
                  doubleLine = true;
                }
                v = v.replace(/---/g, "<hr>");
                v = v.replace(/===/g, "<hr>");
                v = v.replace(/<hr><hr><hr><hr>/g, "<hr>");
                v = v.replace(/<hr><hr><hr>/g, "<hr>");
                v = v.replace(/<hr><hr>/g, "<hr>");
                if (doubleLine) {
                  v = v.replace(/<hr>/, "<hr><hr>");
                }
                tdClass = "text-right";
                table.value += "<tr><td class='" + tdClass + "' colspan='2'>" + v + "</td></tr>";
              } else {
                table.value += "<tr><td colspan='2'>" + v + "</td></tr>";
              }
            }
          }
        });
        table.value += "</table>";
        return table.value;
      }
      return "";
    });
    function checkForZeroAndReplaceWithString(value) {
      if (value == "0.00" || Number(value) == 0 || value == "0,00" || Number(value.replace(/[^0-9.-]+/g, "")) == 0) {
        return dataConfig.noPriceAvailableText;
      } else {
        return value;
      }
    }
    const considerSalesQuantitiesWarning = computed(() => {
      const considerSalesQuantitiesWarns = [];
      const resultData = configuratorStore.resultData;
      if (resultData && resultData.Quantity && resultData.ItemInformation?.Sales) {
        if (parseFloat(resultData.ItemInformation?.Sales?.HighestQty) && parseFloat(resultData.Quantity) > parseFloat(resultData.ItemInformation?.Sales?.HighestQty)) {
          considerSalesQuantitiesWarns.push(t("error.HighestQty").replace("[X]", Number(resultData.ItemInformation.Sales.HighestQty).toFixed(0)));
        }
        if (parseFloat(resultData.ItemInformation?.Sales?.LowestQty) && parseFloat(resultData.Quantity) < parseFloat(resultData.ItemInformation.Sales.LowestQty)) {
          considerSalesQuantitiesWarns.push(t("error.LowestQty").replace("[X]", Number(resultData.ItemInformation.Sales.LowestQty).toFixed(0)));
        }
        if (parseFloat(resultData.ItemInformation?.Sales?.MultipleQty) && parseFloat(resultData.Quantity) % parseFloat(resultData.ItemInformation.Sales.MultipleQty) != 0) {
          considerSalesQuantitiesWarns.push(t("error.MultipleQty").replace("[X]", Number(resultData.ItemInformation.Sales.MultipleQty).toFixed(0)));
        }
      }
      return considerSalesQuantitiesWarns;
    });
    eventBus.on("optionSelected", async res => {
      if (res) {
        if (config.CriteriasChangedSyncPrice) {
          const loading = openFullLoading(false, t("text.loading"));
          await configuratorStore.setResults();
          loading.close();
        }
      }
    });
    eventBus.on("logoClickHandle", async res => {
      if (res) {
        eventBus.emit("logoClickHandle", false);
      }
    });
    const visibleShowPriceDetail = computed(() => dataConfig.isPriceDetailsVisible && configuratorStore.getCurrentState?.CodeComplete && configuratorStore.resultData?.ItemInformation?.Pricing?.PriceText);
    const IsFeasible = computed(() => configuratorStore.apiTechnicalEvaluation?.Result?.IsFeasible);
    eventBus.on("visibleProduct3dWithDownload", async res => {
      visibleProduct3dWithDownload.value = res;
    });
    const dialogShowPriceDetail = ref(false);
    const dialogShowFeasibleDetail = ref(false);
    const dataConfig = additionalStore.getDataConfig;
    const activeName = ref("1");
    const activeImageName = ref("image");
    const activeBodyName = ref("checkout");
    eventBus.on("resetImageSelector", () => {
      activeImageName.value = "image";
    });
    eventBus.on("showTechnicalEvaluationDetails", async res => {
      if (configuratorStore.apiTechnicalEvaluation?.Result.Details) {
        dialogShowFeasibleDetail.value = res;
      }
    });
    function is3dAvailable(currentCoding) {
      // return currentCoding?.HasDesignData;
      return currentCoding?.Complete === "Yes" && currentCoding.HasDesignData;
    }
    const productText = coding => {
      if (typeof coding.ShowFullString === "boolean" && coding.ShowFullString === false) {
        return coding.ContentStringPublic;
      } else if (typeof coding.ShowFullString === "boolean" && coding.ShowFullString === true) {
        return coding.ContentString;
      }
      const contentType = additionalStore.dataConfig.contentStringType;
      if (typeof contentType === "string") {
        if (contentType === "internal") {
          return coding.ContentString;
        }
        // if (contentType === "external") {
        //   return coding?.ContentString + "\n" + coding?.ContentStringPublic;
        // }
      }
      return coding.ContentStringPublic;
    };
    const switchAssemblyType = async codeing => {
      const loading = openFullLoading(false, t("text.loading"));
      try {
        await useConfiguratorStore().ChangeAssembly(codeing.CodeTypeId);
      } finally {
        loading.close();
      }
    };
    function wrapCriteriaChars(chars) {
      const structure = useConfiguratorStore().structure;
      let result = "";
      let currentIndex = 0;
      structure.forEach(({
        Criteria,
        Position
      }) => {
        let active = "";
        if (useConfiguratorStore().getCurrentState?.CurrentCriteria == Criteria) {
          active = "active-code";
        }
        const start = parseInt(Position.Start, 10) - 1;
        const end = parseInt(Position.End, 10);
        // Add characters before the current segment if any
        if (currentIndex < start) {
          result += chars.slice(currentIndex, start);
        }
        // Wrap the segment with a span
        const segment = chars.slice(start, end).replace(/ /g, "&nbsp;");
        result += `<span data-criteria="${Criteria}" class="criteria ${useConfiguratorStore().codeHoverOn == Criteria ? "order-code-hovered" : ""} ${active} ${Criteria}">${segment}</span>`;
        currentIndex = end;
      });
      if (currentIndex < chars.length) {
        result += chars.slice(currentIndex);
      }
      return result;
    }
    // const handleMouseEnterCriteria = (event: Event) => {
    //   alert("test");
    //   const target = event.target as HTMLElement | null;
    //   const span = target?.closest(".criteria") as HTMLSpanElement | null;
    //   if (span) {
    //     console.log(span);
    //     useConfiguratorStore().setCodeHoverOn(span.getAttribute("data-criteria"));
    //   }
    // };
    const handleClick = event => {
      const target = event.target;
      const span = target?.closest(".criteria");
      if (span) {
        const criteria = span.getAttribute("data-criteria");
        if (criteria) {
          useConfiguratorStore().getCurrentState?.CurrentCoding.map(codes => {
            codes.Criterias.forEach(criterias => {
              if (criterias.CriteriaId == criteria) {
                const el = document.querySelector(".configurator-header.configurator-layout");
                if (el) {
                  const headerHeight = el.getBoundingClientRect().height;
                  const elActive = document.querySelector("[data-type='" + criteria + "']");
                  if (elActive && typeof elActive.scrollIntoView === "function") {
                    if (elActive.firstElementChild) {
                      elActive.firstElementChild.click();
                    }
                    elActive.scrollIntoView({
                      behavior: "smooth",
                      block: "center"
                    });
                    window.scrollBy(0, -headerHeight);
                  } else {
                    console.warn("Element not found or scrollIntoView not available");
                  }
                }
              }
            });
          });
        }
      }
    };
    const fullContentString = computed(() => {
      const selectedAssembly = configuratorStore.getSelectedAssembly;
      return selectedAssembly && is3dAvailable(selectedAssembly) ? selectedAssembly.ContentStringPublic : "";
    });
    const cadenasBaseUrl = computed(() => {
      return additionalStore.config.cadenasBaseUrl;
    });
    const tooltipTextForbutton = computed(() => {
      if (configuratorStore.getCurrentState?.CodeComplete) {
        return "label.configurationComplete";
      } else {
        return "label.configurationInComplete";
      }
    });
    watch(fullContentString, newValue => {
      if (!newValue && activeImageName.value === "d3") {
        activeImageName.value = "";
      }
    });
    const selectedAssembly = computed(() => configuratorStore.getSelectedAssembly);
    watch(selectedAssembly, newValue => {
      if (newValue && is3dAvailable(newValue)) {
        activeImageName.value = "d3";
      }
    });
    const handleCopyTypecode = async (code, event) => {
      if (code !== "") {
        try {
          await toClipboard(code ?? "");
          const Icon = event.currentTarget;
          Icon.style.color = "#00A36D";
          const inner = Icon.innerHTML;
          Icon.innerHTML = `
            <svg viewBox="0 0 1024 1024" style="width:20px;height:20px;" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M392.533333 806.4L85.333333 503.466667l59.733334-59.733334 247.466666 247.466667L866.133333 213.333333l59.733334 59.733334L392.533333 806.4z" fill="#00A36D"></path></svg>
      `;
          setTimeout(() => {
            Icon.style.color = "";
            Icon.innerHTML = inner;
          }, 50000);
        } catch (error) {
          console.error(error);
        }
      }
    };
    const defaultSummaryLabel = computed(() => {
      let label = "";
      if (options.value.length > 1) {
        if (isDetailLabel.value) {
          label = labelDetail;
        } else if (isOverviewLabel.value) {
          label = labelOverview;
        }
      } else if (isDetailLabel.value) {
        label = labelDetail;
      }
      return label;
    });
    const options = computed(() => {
      const cs = configuratorStore.getCurrentState;
      const cr = [];
      if (cs?.CurrentDescription != cs?.CurrentDescriptionLong) {
        cr.push({
          value: "overview",
          label: labelOverview
        });
        cr.push({
          value: "detail",
          label: labelDetail
        });
      } else {
        cr.push({
          value: "detail",
          label: labelDetail
        });
      }
      return cr;
    });
    const isOverviewLabel = ref(true);
    const isDetailLabel = ref(false);
    const handleSummaryChange = command => {
      if (command === "detail") {
        isOverviewLabel.value = false;
        isDetailLabel.value = true;
      } else {
        isOverviewLabel.value = true;
        isDetailLabel.value = false;
      }
    };
    const visibleShowMore = ref(false);
    const exampleInput = ref("");
    const showMoreElement = ref();
    const showMoreHeight = ref(0);
    const showMoreIsInit = ref(false);
    const handleVisibleShowMore = () => {
      visibleShowMore.value = !visibleShowMore.value;
      getWindowResize();
      if (showMoreIsInit.value) {
        showMoreElement.value.$el.style.maxHeight = visibleShowMore.value ? showMoreHeight.value + "px" : 0;
      }
      setTimeout(() => {
        handleScroll();
      }, 200);
    };
    eventBus.on("showMore", () => {
      visibleShowMore.value = true;
      getWindowResize();
      if (showMoreElement.value) {
        showMoreElement.value.$el.style.maxHeight = showMoreHeight.value + "px";
      }
    });
    eventBus.on("optonButtonItemClick", item => {
      if (typeof item === "object") {
        handleButton(item, eventBus);
        eventBus.emit("optonButtonItemClick", false);
      }
    });
    eventBus.on("switchToProductImage", isVisible => {
      if (isVisible) {
        activeImageName.value = "image";
      }
    });
    const refSummary = ref();
    const sideHeight = ref(400);
    const getWindowResize = () => {
      sideHeight.value = window.innerHeight - 72;
      if (showMoreElement.value && showMoreElement.value.$el.clientHeight > 0) {
        showMoreHeight.value = showMoreElement.value.$el.clientHeight + 50;
        showMoreIsInit.value = true;
      }
    };
    onMounted(async () => {
      window.addEventListener("resize", handleScroll);
    });
    const configuratorState = computed(() => configuratorStore.getCurrentState);
    watch(configuratorState, async () => {
      await nextTick();
      setTimeout(() => {
        handleScroll();
      }, 200);
      window.addEventListener("resize", getWindowResize);
      getWindowResize();
    });
    onUnmounted(() => {
      eventBus.off("configurationCompleted");
    });
    let timeout = null;
    const qty = ref(quantity.value);
    const debounce = (func, wait) => {
      return (...args) => {
        if (timeout !== null) {
          clearTimeout(timeout);
        }
        eventBus.emit("pcQtyChanged", args[0]);
        timeout = setTimeout(() => {
          func(...args);
        }, wait);
      };
    };
    eventBus.on("mobileQtyChanged", item => {
      qty.value = item;
    });
    const debounceOnqtychanges = debounce(onQuantityChanged, 800);
    const getFieldValue = field => {
      if (field.Type == "string") {
        return field.Value;
      }
      if (field.Type == "bool") {
        return field.Value ? t("button.yes") : t("button.no");
      }
      if (field.Type == "number") {
        const customNumberValue = new Intl.NumberFormat(useAdditionalAttrStore().getlangValue).format(Number(field.Value));
        return customNumberValue;
      }
    };
    return (_ctx, _cache) => {
      const _component_product_summary_promo = _resolveComponent("product-summary-promo");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_text = _resolveComponent("el-text");
      const _component_CopyDocument = _resolveComponent("CopyDocument");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "summary",
        ref_key: "refSummary",
        ref: refSummary
      }, [_createVNode(_component_el_scrollbar, {
        ref: "scrollbar",
        "max-height": sideHeight.value,
        class: "summary-scroll",
        onScroll: handleScroll
      }, {
        default: _withCtx(() => [_createVNode(_component_product_summary_promo), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [imageUrl.value || _unref(configuratorStore).getIsCodingImageSet ? (_openBlock(), _createBlock(_component_el_link, {
          key: 0,
          class: "abs abs-full",
          type: "default",
          onClick: _cache[0] || (_cache[0] = $event => handleFullscreen())
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "fullscreen"
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_tabs, {
          modelValue: activeImageName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activeImageName.value = $event),
          class: "tabs-image"
        }, {
          default: _withCtx(() => [imageUrl.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            name: "image"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_tooltip, {
              content: _ctx.$t('label.productPhoto')
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "toggle-picture-default",
                "class-name": "with-default"
              }, null, 512), [[_vShow, hasImage.value]])]),
              _: 1
            }, 8, ["content"]), _createVNode(_component_el_tooltip, {
              content: _ctx.$t('label.productPhoto')
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "toggle-picture-active",
                "class-name": "with-active"
              }, null, 512), [[_vShow, hasImage.value]])]),
              _: 1
            }, 8, ["content"])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_unref(additionalStore).dataConfig.shellModels && _unref(additionalStore).dataConfig.shellModels?.length > 0 && isShellInArr.value && getAllimages.value && _unref(configuratorStore)?.getCurrentType == _unref(configuratorStore)?.getCurrentState?.CurrentCoding[0].CodeTypeId ? (_openBlock(), _createElementBlock("div", _hoisted_4, [getAllimages.value && getAllimages.value.length > 1 ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAllimages.value, (images, index) => {
                return _openBlock(), _createBlock(_component_el_col, {
                  key: index,
                  span: 12,
                  style: {
                    "padding": "4%",
                    "margin": "0 auto"
                  }
                }, {
                  default: _withCtx(() => [images ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    src: images,
                    fit: "contain",
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["src"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024);
              }), 128))]),
              _: 1
            })) : (_openBlock(), _createElementBlock("div", _hoisted_5, [getAllimages.value && getAllimages.value.length === 1 ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: getAllimages.value[0],
              fit: "contain",
              style: {
                "width": "320px",
                "height": "320px"
              }
            }, null, 8, ["src"])) : _createCommentVNode("", true)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_image, {
              src: imageUrl.value,
              fit: "contain",
              style: {
                "width": "320px",
                "height": "320px"
              }
            }, null, 8, ["src"])]))])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(configuratorStore).getIsCodingImageSet ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            name: "d2"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_tooltip, {
              content: _ctx.$t('label.technicalDrawing')
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "toggle-2D-default",
                "class-name": "with-default"
              }, null, 512), [[_vShow, hasImage.value]])]),
              _: 1
            }, 8, ["content"]), _createVNode(_component_el_tooltip, {
              content: _ctx.$t('label.technicalDrawing')
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "toggle-2D-active",
                "class-name": "with-active"
              }, null, 512), [[_vShow, hasImage.value]])]),
              _: 1
            }, 8, ["content"])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
              src: _unref(configuratorStore).getCodingImageState,
              fit: "contain",
              style: {
                "width": "320px",
                "height": "320px"
              }
            }, null, 8, ["src"])])]),
            _: 1
          })) : _createCommentVNode("", true), selectedAssembly.value?.HasDesignData ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            disabled: !fullContentString.value,
            name: "d3"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_tooltip, {
              content: _ctx.$t('error.web3dViewerIncomplete'),
              disabled: !!fullContentString.value
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                "icon-class": "toggle-3D-default",
                "class-name": "with-default"
              })]),
              _: 1
            }, 8, ["content", "disabled"]), _createVNode(_component_el_tooltip, {
              content: _ctx.$t('label.illustration')
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                "icon-class": "toggle-3D-active",
                "class-name": "with-active"
              })]),
              _: 1
            }, 8, ["content"])]),
            default: _withCtx(() => [_createVNode(Web3dViewer, {
              cadenasBaseUrl: cadenasBaseUrl.value,
              "public-content-string": fullContentString.value
            }, null, 8, ["cadenasBaseUrl", "public-content-string"])]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_tabs, {
          modelValue: activeBodyName.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => activeBodyName.value = $event),
          class: "tabs-checkout"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            disabled: _unref(configuratorStore).buttonIsLoading,
            label: _ctx.$t('label.checkOut'),
            name: "checkout",
            "element-loading-text": _unref(useLoaderStore)().getTechnicalLoading ? _ctx.$t('label.priceSectionLoadingTechnical') : _ctx.$t('label.priceSectionLoading')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              gutter: 20,
              class: "hide-mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("label.amount")) + ":", 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [considerSalesQuantitiesWarning.value?.length && _unref(additionalStore).dataConfig.considerSalesQuantities ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  "popper-class": "tooltip-item",
                  placement: "left"
                }, {
                  content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(considerSalesQuantitiesWarning.value, warn => {
                    return _openBlock(), _createElementBlock("span", {
                      key: warn
                    }, [_createTextVNode(_toDisplayString(warn) + " ", 1), _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))]);
                  }), 128))]),
                  default: _withCtx(() => [_createVNode(_component_svg_icon, {
                    class: "iconfont WarnTriangleFilled",
                    "icon-class": "WarnTriangleFilled"
                  })]),
                  _: 1
                })) : _createCommentVNode("", true), _createVNode(_component_el_input_number, {
                  modelValue: qty.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => qty.value = $event),
                  min: _unref(dataConfig).minQty || 1,
                  max: _unref(dataConfig).maxQty,
                  onChange: _unref(debounceOnqtychanges)
                }, null, 8, ["modelValue", "min", "max", "onChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, {
              class: _normalizeClass({
                'show-more-options': true,
                'show-more-init': showMoreIsInit.value,
                show: visibleShowMore.value
              }),
              ref_key: "showMoreElement",
              ref: showMoreElement
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" ", -1)]))]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t("label.itemNo")) + ":", 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_unref(dataConfig).hideOrmig == true && _unref(configuratorStore).resultData?.ItemInformation?.Item?.IsOrmigNumber == true ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createTextVNode(_toDisplayString(_ctx.$t("label.hideOrmigText")), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_createTextVNode(_toDisplayString(itemNumber.value), 1)], 64))]),
                _: 1
              }), _unref(configuratorStore)?.getRequireTechnicalEvaluation && _unref(configuratorStore).getCurrentState?.CodeComplete == true ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.$t("label.technicalEvaluation")) + ":", 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(configuratorStore)?.getRequireTechnicalEvaluation && _unref(configuratorStore).getCurrentState?.CodeComplete == true ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: _normalizeClass(`${IsFeasible.value ? 'text-success' : 'text-danger'}`)
                }, _toDisplayString(IsFeasible.value ? _ctx.$t("label.technicalEvaluationPass") : _ctx.$t("label.technicalEvaluationFail")), 3), _unref(configuratorStore).apiTechnicalEvaluation?.Result.Details ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "technical-link",
                  onClick: _cache[3] || (_cache[3] = $event => dialogShowFeasibleDetail.value = !dialogShowFeasibleDetail.value)
                }, [_createElementVNode("span", null, [_createVNode(_component_svg_icon, {
                  "icon-class": "icon-tooltip-info",
                  class: "te-icon"
                })])])) : _createCommentVNode("", true)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(configuratorStore).apiexternalitemid ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [_createVNode(_component_el_col, {
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.$t("label.itemExternalNo")) + ":", 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(itemExternalNo.value), 1)]),
                _: 1
              })], 64)) : _createCommentVNode("", true), !_unref(dataConfig).disableCustomerNo ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 3
              }, [_createVNode(_component_el_col, {
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.$t("label.CustomItemNo")) + ":", 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 14,
                class: "text-right"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_input, {
                  modelValue: exampleInput.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => exampleInput.value = $event),
                  maxlength: "200",
                  class: "limit-input",
                  placeholder: "Type something ...",
                  type: "text"
                }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                  type: "primary"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                  _: 1
                })])]),
                _: 1
              })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider), terminationError.value ? (_openBlock(), _createBlock(_component_el_col, {
                key: 4,
                span: 24
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_svg_icon, {
                  "icon-class": "icon-tooltip-info",
                  class: "te-icon"
                }), _createTextVNode(" " + _toDisplayString(_ctx.$t("label.terminationError")), 1)])]),
                _: 1
              })) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 5
              }, [_unref(dataConfig).displayDispatchInformation ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_15, _toDisplayString(_ctx.$t("label.readyForDespatch")) + ":", 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(dataConfig).displayDispatchInformation ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(priceInformation).readyForDispatch), 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(dataConfig).isDeliveryDateExp ? (_openBlock(), _createBlock(_component_el_col, {
                key: 2,
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_16, _toDisplayString(_unref(dataConfig).showDeliveryDateInbound ? _ctx.$t("label.expDeliveryDateInbound") : _ctx.$t("label.expDeliveryDate")) + ":", 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(dataConfig).isDeliveryDateExp ? (_openBlock(), _createBlock(_component_el_col, {
                key: 3,
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(priceInformation).expDeliveryDate), 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(additionalStore).dataConfig.stockOnHandVisible ? (_openBlock(), _createBlock(_component_el_col, {
                key: 4,
                span: 10
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_17, _toDisplayString(_ctx.$t("label.stockOnHand")) + ":", 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(additionalStore).dataConfig.stockOnHandVisible ? (_openBlock(), _createBlock(_component_el_col, {
                key: 5,
                span: 14,
                class: "desc"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(priceInformation).stockOnHand), 1)]),
                _: 1
              })) : _createCommentVNode("", true)], 64)), _createVNode(_component_el_divider)]),
              _: 1
            }, 8, ["class"]), _unref(configuratorStore).resultData && _unref(configuratorStore).resultData.ItemInformation && _unref(configuratorStore).resultData?.ItemInformation?.Item?.CustomFields?.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).resultData?.ItemInformation?.Item?.CustomFields, field => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: field.Name
                }, [_createVNode(_component_el_col, {
                  span: 10
                }, {
                  default: _withCtx(() => [_createElementVNode("strong", _hoisted_18, _toDisplayString(field.Name), 1)]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  span: 14,
                  class: "desc"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(getFieldValue(field) || field.Value), 1)]),
                  _: 2
                }, 1024)], 64);
              }), 128)), _createVNode(_component_el_divider)]),
              _: 1
            })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_row, {
              gutter: 20
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode(" ", -1)]))]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.$t("label.unitPrice")) + ":", 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [_createElementVNode("label", null, _toDisplayString(checkForZeroAndReplaceWithString(_unref(priceInformation).unitPrice)), 1)]),
                _: 1
              }), _unref(priceInformation).showAdditionalPrice ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 12
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_20, _toDisplayString(_ctx.$t("label.additionalPrice")) + ":", 1)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(priceInformation).showAdditionalPrice ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [_createElementVNode("label", null, _toDisplayString(checkForZeroAndReplaceWithString(_unref(priceInformation).additionalPrice)), 1)]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("label.total")) + ":", 1), _createElementVNode("label", null, [_createTextVNode(_toDisplayString(_ctx.$t("label.exclVat")) + " ", 1), _unref(dataConfig).shippingDetailUrl ? (_openBlock(), _createElementBlock("span", _hoisted_21, [_cache[24] || (_cache[24] = _createTextVNode("& ", -1)), _createVNode(_component_el_link, {
                  type: "primary",
                  target: "_blank",
                  class: "shipping",
                  href: _unref(dataConfig).shippingDetailUrl
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("link.shipping")), 1)]),
                  _: 1
                }, 8, ["href"])])) : _createCommentVNode("", true)])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [_createElementVNode("strong", _hoisted_22, _toDisplayString(checkForZeroAndReplaceWithString(_unref(priceInformation).totalPrice)), 1)]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, _unref(additionalStore).dataConfig.showPricing]]), _createVNode(_component_el_row, {
              gutter: 20
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" ", -1)]))]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  type: "primary",
                  class: "get-more",
                  onClick: handleVisibleShowMore
                }, {
                  default: _withCtx(() => [visibleShowMore.value ? (_openBlock(), _createElementBlock("label", _hoisted_23, [_cache[26] || (_cache[26] = _createElementVNode("span", {
                    class: "minus"
                  }, "-", -1)), _createTextVNode(_toDisplayString(_ctx.$t("button.showLess")), 1)])) : (_openBlock(), _createElementBlock("label", _hoisted_24, [_cache[27] || (_cache[27] = _createElementVNode("span", {
                    class: "plus"
                  }, "+", -1)), _createTextVNode(_toDisplayString(_ctx.$t("button.showMore")), 1)]))]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12,
                class: "rb"
              }, {
                default: _withCtx(() => [visibleShowPriceDetail.value ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  class: "get-more",
                  onClick: _cache[5] || (_cache[5] = $event => dialogShowPriceDetail.value = !dialogShowPriceDetail.value)
                }, {
                  default: _withCtx(() => [_createElementVNode("label", null, _toDisplayString(_ctx.$t("link.showPriceDetails")), 1)]),
                  _: 1
                })) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled", "label", "element-loading-text"])), [[_directive_loading, _unref(useLoaderStore)().getSummaryLoading || _unref(useLoaderStore)().getTechnicalLoading]]), _createVNode(_component_el_tab_pane, {
            disabled: _unref(configuratorStore).buttonIsLoading,
            label: _ctx.$t('label.typecode'),
            name: "second"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "form-layout"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("header.orderCode")), 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [_unref(configuratorStore).getCurrentState?.CodeComplete ? (_openBlock(), _createBlock(_component_el_text, {
                  key: 0,
                  class: "mx-1",
                  type: "success"
                }, {
                  default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("i", {
                    class: "iconfont icon-right"
                  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("label.configurationComplete")), 1)]),
                  _: 1
                })) : _createCommentVNode("", true)]),
                _: 1
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedProductsForCodes.value, (coding, key) => {
                return _openBlock(), _createBlock(_component_el_col, {
                  key: key,
                  span: 24
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [coding.CodeTypeId == _unref(configuratorStore).getCurrentState?.CurrentCoding.find(_unref(isProductSelected))?.CodeTypeId ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
                    class: "criteria__wrapper active-order-code",
                    innerHTML: wrapCriteriaChars(productText(coding)),
                    onClick: handleClick
                  }, null, 8, _hoisted_28)])])) : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: $event => switchAssemblyType(coding)
                  }, [_unref(additionalStore).dataConfig.contentStringType === 'external' ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    value: productText(coding),
                    readonly: "",
                    type: "textarea",
                    class: "criteria__wrapper"
                  }, null, 8, ["value"])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
                    class: "criteria__wrapper active-order-code",
                    innerHTML: productText(coding)
                  }, null, 8, _hoisted_32)])]))], 8, _hoisted_29)), _createVNode(_component_el_icon, {
                    onClick: event => handleCopyTypecode(productText(coding), event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
                    _: 1
                  }, 8, ["onClick"])])]),
                  _: 2
                }, 1024);
              }), 128)), _createVNode(_component_el_col, {
                span: 24,
                class: "text-right"
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: "wikaButtonConf",
                  "data-colour": "white",
                  "data-no-border": "",
                  onClick: _cache[6] || (_cache[6] =
                  //@ts-ignore
                  (...args) => _unref(handleShareQrcode) && _unref(handleShareQrcode)(...args)),
                  disabled: _unref(configuratorStore).buttonIsLoading,
                  "data-text": _ctx.$t('button.shareCode'),
                  "data-type": "button",
                  id: "shareCode"
                }, _toDisplayString(_ctx.$t("button.shareCode")), 9, _hoisted_33)]),
                _: 1
              }), _createVNode(_component_el_divider), _createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("search.code.heading")), 1), _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("search.code.text")), 1)]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_input, {
                  value: "",
                  modelValue: loadCode.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => loadCode.value = $event),
                  maxlength: "10",
                  onKeyup: _withKeys(handleLoadCode, ["enter"])
                }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                  class: "has-text-white",
                  type: "primary",
                  id: "loadCode",
                  onClick: handleLoadCode
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled", "label"])]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", {
          class: _normalizeClass(["summary-controls hide-mobile", {
            'sticky-active': isTopSticky.value || isBottomSticky.value
          }])
        }, [_withDirectives(_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_tooltip, {
          "popper-class": "tooltip-item",
          content: _ctx.$t(tooltipTextForbutton.value),
          placement: "left"
        }, {
          default: _withCtx(() => [_unref(configuratorStore).getCurrentState?.CodeComplete ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[29] || (_cache[29] = [_createElementVNode("i", {
            class: "iconfont icon-status-success"
          }, null, -1)]))])) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            "icon-class": "writing"
          }))]),
          _: 1
        }, 8, ["content"])], 512), [[_vShow, _unref(additionalStore).getDataConfig.environment == 'CustomerPortal']]), _createVNode(_component_el_dropdown, {
          class: "control-dropdown",
          "popper-class": "configurator-dropdown",
          trigger: "click",
          disabled: _unref(useLoaderStore)().getSummaryLoading,
          id: "configuratorMoreOptions"
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
            class: "configurator-dropdown-options"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moreButtons), (item, key) => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                key: key,
                divided: item.showSeparatorAbove,
                class: _normalizeClass(item.isMenu ? 'menuclass ' + item.class : item.class),
                id: item.label ? item.label.replace(/\W/g, '_') : '',
                disabled: _unref(useLoaderStore)().getSummaryLoading || item.isMenu ? false : _unref(checkGetDatasheetPermission)(item),
                onClick: $event => item.isMenu ? '' : _unref(handleButton)(item, _unref(eventBus))
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: "nested-dropdown-value",
                  onClick: _cache[9] || (_cache[9] = $event => openToggleMenu($event))
                }, [_createElementVNode("div", null, [item.icon === 'e-mail' ? (_openBlock(), _createElementBlock("i", _hoisted_39)) : _createCommentVNode("", true), item.icon === 'quit' ? (_openBlock(), _createElementBlock("i", _hoisted_40)) : _createCommentVNode("", true), item.icon === 'heart' ? (_openBlock(), _createElementBlock("i", _hoisted_41)) : _createCommentVNode("", true), item.icon === 'download' ? (_openBlock(), _createElementBlock("i", _hoisted_42)) : _createCommentVNode("", true), item.icon === 'help' ? (_openBlock(), _createElementBlock("i", _hoisted_43)) : _createCommentVNode("", true), item.icon === 'cart' ? (_openBlock(), _createElementBlock("i", _hoisted_44)) : _createCommentVNode("", true), item.icon === 'upload' ? (_openBlock(), _createElementBlock("i", _hoisted_45)) : _createCommentVNode("", true), item.icon === 'invoice' ? (_openBlock(), _createElementBlock("i", _hoisted_46)) : _createCommentVNode("", true), item.icon === 'reset' ? (_openBlock(), _createElementBlock("i", _hoisted_47)) : _createCommentVNode("", true), item.icon === 'compass' ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 9,
                  "icon-class": "compass-drafting"
                })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_48, _toDisplayString(item.label), 1)]), item.isMenu ? (_openBlock(), _createElementBlock("span", _hoisted_49, [_createVNode(_component_svg_icon, {
                  "icon-class": "chevron-down-blue"
                })])) : _createCommentVNode("", true)]), item.isMenu ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createVNode(_component_el_scrollbar, {
                  height: _unref(getSubMenuHeight)(item.childs?.length)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_menu, {
                    mode: "vertical"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, (child, key) => {
                      return _openBlock(), _createBlock(_component_el_menu_item, {
                        disabled: _unref(checkGetDatasheetPermission)(child),
                        onClick: $event => _unref(handleButton)(child, _unref(eventBus)),
                        key: key
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(child.label), 1)]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]);
                    }), 128))]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["height"])])) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["divided", "class", "id", "disabled", "onClick"]);
            }), 128))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "wikaButtonConf",
            "data-colour": "white",
            disabled: _unref(useLoaderStore)().getSummaryLoading,
            "data-no-border": "",
            "data-text": _ctx.$t('button.moreOptions'),
            "data-type": "button",
            id: "moreOptions"
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "more-options"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.moreOptions")), 1)], 8, _hoisted_38)]),
          _: 1
        }, 8, ["disabled"]), _unref(primaryButton) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wikaButtonConf",
          "data-colour": _unref(primaryButton).class ? _unref(primaryButton).class : 'dark-blue',
          "data-no-border": "",
          "data-text": _unref(primaryButton).label,
          id: _unref(primaryButton).label ? _unref(primaryButton).label.replace(/\W/g, '_') : '',
          "data-type": "button",
          disabled: _unref(useLoaderStore)().getSummaryLoading || _unref(checkGetDatasheetPermission)(_unref(primaryButton), true),
          onClick: _cache[10] || (_cache[10] = $event => _unref(useLoaderStore)().getSummaryLoading || _unref(checkGetDatasheetPermission)(_unref(primaryButton), true) ? '' : _unref(handleButton)(_unref(primaryButton), _unref(eventBus), true))
        }, [_unref(primaryButton).icon === 'cart' ? (_openBlock(), _createElementBlock("i", _hoisted_52)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'e-mail' ? (_openBlock(), _createElementBlock("i", _hoisted_53)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'quit' ? (_openBlock(), _createElementBlock("i", _hoisted_54)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'heart' ? (_openBlock(), _createElementBlock("i", _hoisted_55)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'download' ? (_openBlock(), _createElementBlock("i", _hoisted_56)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'upload' ? (_openBlock(), _createElementBlock("i", _hoisted_57)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'invoice' ? (_openBlock(), _createElementBlock("i", _hoisted_58)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'reset' ? (_openBlock(), _createElementBlock("i", _hoisted_59)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_unref(primaryButton).label), 1)], 8, _hoisted_51)) : _createCommentVNode("", true)], 2), _unref(configuratorStore).getCurrentState ? (_openBlock(), _createBlock(_component_el_collapse, {
          key: 0,
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => activeName.value = $event),
          class: "summary-collapse"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            name: "1"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("header.summary")), 1)])])]),
            default: _withCtx(() => [options.value.length > 1 ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              onCommand: handleSummaryChange,
              class: "summary-dropdown",
              "popper-class": "configurator-dropdown",
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, item => {
                  return _openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: item.value,
                    command: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(item.label)), 1)]),
                    _: 2
                  }, 1032, ["command"]);
                }), 128))]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_62, [_createTextVNode(_toDisplayString(_unref(t)(defaultSummaryLabel.value)) + " ", 1), _createVNode(_component_svg_icon, {
                "icon-class": "chevron-down-1"
              })])]),
              _: 1
            })) : (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_unref(t)(defaultSummaryLabel.value)), 1)), isOverviewLabel.value ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              innerHTML: _unref(configuratorStore).getCurrentState.CurrentDescription.replace(/\n/g, '<br>')
            }, null, 8, _hoisted_64)) : _createCommentVNode("", true), isDetailLabel.value ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              innerHTML: _unref(configuratorStore).getCurrentState.CurrentDescriptionLong.replace(/\n/g, '<br>')
            }, null, 8, _hoisted_65)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["max-height"])], 512), _createVNode(_component_el_dialog, {
        modelValue: dialogShowPriceDetail.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => dialogShowPriceDetail.value = $event),
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_cache[30] || (_cache[30] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.pricingDetail")), 1)]), _createElementVNode("div", {
          class: "desc",
          innerHTML: priceDetailHtml.value
        }, null, 8, _hoisted_69)])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: dialogShowFeasibleDetail.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => dialogShowFeasibleDetail.value = $event),
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_70, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.feasibleDetail")), 1)]), _createElementVNode("div", {
          class: "desc",
          innerHTML: _unref(configuratorStore).apiTechnicalEvaluation?.Result.Details?.replace(/\n/g, '<br>')
        }, null, 8, _hoisted_73)])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogShowQrcode),
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _isRef(dialogShowQrcode) ? dialogShowQrcode.value = $event : null),
        "destroy-on-close": "",
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_cache[33] || (_cache[33] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.shareCode")), 1), _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("text.dialog.shareCode")), 1)]), _createElementVNode("ul", _hoisted_78, [_createElementVNode("li", null, [_createVNode(_component_el_row, {
          gutter: 20,
          class: "row-m480"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_unref(qrCodeStr) ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_createVNode(_component_el_image, {
              style: {
                "width": "128px",
                "height": "128px"
              },
              fit: "contain",
              src: _unref(additionalStore).config.qrURI + _unref(qrCodeStr)
            }, null, 8, ["src"])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 18
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_el_input, {
              modelValue: _unref(buildCodeInput),
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _isRef(buildCodeInput) ? buildCodeInput.value = $event : null),
              onClick: _unref(copyQrCodeHandle),
              readonly: ""
            }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_el_link, {
              class: "copy-link",
              onClick: _unref(copyQrCodeHandle)
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createElementVNode("i", {
                class: "iconfont icon-copy"
              }, null, -1)]))]),
              _: 1
            }, 8, ["onClick"])]), _unref(qrCodeStr) ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_createTextVNode(_toDisplayString(_ctx.$t("label.directLink")) + " ", 1), _createVNode(_component_el_link, {
              href: _unref(additionalStore).config.qrIdURI + _unref(qrCodeStr),
              target: "_blank"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(additionalStore).config.qrIdURI + _unref(qrCodeStr)), 1)]),
              _: 1
            }, 8, ["href"])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24,
            class: "col-splicer"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(shareCodeExpairText)), 1)]),
            _: 1
          })]),
          _: 1
        })])]), _unref(additionalStore).dataConfig?.buildIdModalSection ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_82, [_createElementVNode("h4", _hoisted_83, _toDisplayString(_unref(additionalStore).dataConfig?.buildIdModalSection?.title), 1)])]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20,
          class: "row-m480 mt5 mb10"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 17,
            lg: 17,
            span: 17
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, _toDisplayString(_unref(additionalStore).dataConfig?.buildIdModalSection?.text), 1)])]),
            _: 1
          }), _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 7,
            lg: 7,
            span: 7
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", {
              class: "wikaButtonConf",
              "data-colour": _unref(additionalStore).dataConfig?.buildIdModalSection?.button.class ? _unref(additionalStore).dataConfig?.buildIdModalSection?.button?.class : 'transparent',
              "data-no-border": "",
              onClick: _cache[15] || (_cache[15] = $event => _unref(additionalStore).dataConfig?.buildIdModalSection?.button ? _unref(handleButton)(_unref(additionalStore).dataConfig?.buildIdModalSection?.button, _unref(eventBus)) : ''),
              disabled: _unref(additionalStore).dataConfig?.buildIdModalSection?.button ? _unref(checkGetDatasheetPermission)(_unref(additionalStore).dataConfig?.buildIdModalSection?.button) : false,
              "data-text": _ctx.$t('button.shareCode'),
              "data-type": "button"
            }, [_unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'e-mail' ? (_openBlock(), _createElementBlock("i", _hoisted_88)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'quit' ? (_openBlock(), _createElementBlock("i", _hoisted_89)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'heart' ? (_openBlock(), _createElementBlock("i", _hoisted_90)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'download' ? (_openBlock(), _createElementBlock("i", _hoisted_91)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'help' ? (_openBlock(), _createElementBlock("i", _hoisted_92)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'cart' ? (_openBlock(), _createElementBlock("i", _hoisted_93)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'upload' ? (_openBlock(), _createElementBlock("i", _hoisted_94)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'invoice' ? (_openBlock(), _createElementBlock("i", _hoisted_95)) : _createCommentVNode("", true), _unref(additionalStore).dataConfig?.buildIdModalSection?.button.icon === 'reset' ? (_openBlock(), _createElementBlock("i", _hoisted_96)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(additionalStore).dataConfig?.buildIdModalSection?.button?.label), 1)], 8, _hoisted_87)])]),
            _: 1
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_vue_easy_lightbox, {
        escDisabled: "",
        visible: visibleProductImage.value,
        imgs: configuratorProductImage.value,
        index: 1,
        onHide: _cache[17] || (_cache[17] = $event => visibleProductImage.value = !visibleProductImage.value)
      }, null, 8, ["visible", "imgs"]), _createVNode(_component_vue_easy_lightbox, {
        escDisabled: "",
        visible: visibleProduct2d.value,
        imgs: configuratorProduct2d.value,
        index: 1,
        onHide: _cache[18] || (_cache[18] = $event => visibleProduct2d.value = !visibleProduct2d.value)
      }, null, 8, ["visible", "imgs"]), _createVNode(_component_el_dialog, {
        modelValue: visibleProduct3d.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => visibleProduct3d.value = $event),
        modal: true,
        "modal-class": "in-lightbox-shadow",
        "destroy-on-close": "",
        "show-close": true,
        fullscreen: true,
        "before-close": closeProduct3d,
        "close-on-press-escape": false
      }, {
        default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "shadow"
        }, null, -1)), _createElementVNode("div", _hoisted_98, [_createVNode(Web3dViewer, {
          cadenasBaseUrl: cadenasBaseUrl.value,
          "public-content-string": fullContentString.value
        }, null, 8, ["cadenasBaseUrl", "public-content-string"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: visibleProduct3dWithDownload.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => visibleProduct3dWithDownload.value = $event),
        modal: true,
        "modal-class": "in-lightbox-shadow",
        "destroy-on-close": "",
        "show-close": true,
        fullscreen: true,
        "before-close": closeProduct3dDownload,
        "close-on-press-escape": false
      }, {
        default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("div", {
          class: "shadow"
        }, null, -1)), _createElementVNode("div", _hoisted_99, [_createVNode(Web3dViewer, {
          cadenasBaseUrl: cadenasBaseUrl.value,
          "public-content-string": fullContentString.value,
          "is-fullscreen": "true"
        }, null, 8, ["cadenasBaseUrl", "public-content-string"])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});